<script setup lang="tsx">
import type { RiskOverviewRisks } from '@/models/api-generated'
import CardRow from './CardRow.vue'
import { RT_Unscored } from '@/models/enums-generated'

const model = defineModel<RiskOverviewRisks>({ required: true })

const emit = defineEmits<{
	(e: 'go-to-risks', riskNames: string[], treatments: string[]): void
}>()

function goToRisks(name: string[], treatment: string[]) {
	emit('go-to-risks', name, treatment)
}
</script>

<template>
	<div class="rounded-container p-4">
		<p class="text-center fw-bold">
			{{ $t('risk.risk', 1) }}
		</p>

		<table class="w-100">
			<CardRow>
				<template #col0>{{ $t('risk.overview.total') }}</template>
				<template #col_end>{{ model.total }}</template>
			</CardRow>
			<CardRow>
				<template #col0>
					<span class="risks-cell" v-one-tooltip="model.overAcceptable.join(', ')" @click="goToRisks(model.overAcceptable, [])">{{
						$t('risk.overview.overAcceptable')
					}}</span></template
				>
				<template #col_end>
					<span class="red">{{ model.overAcceptable.length }}</span>
				</template>
			</CardRow>
			<CardRow>
				<template #col0>
					<span class="risks-cell" @click="goToRisks([], [RT_Unscored])">{{ $t('risk.overview.unscored') }}</span>
				</template>
				<template #col_end>
					<span class="red">{{ model.unscored }}</span>
				</template>
			</CardRow>
			<CardRow>
				<template #col0>
					<span class="risks-cell" v-one-tooltip="model.overDeadline.join(', ')" @click="goToRisks(model.overDeadline, [])">{{
						$t('risk.overview.overDeadline')
					}}</span></template
				>
				<template #col_end>
					<span class="red">{{ model.overDeadline.length }}</span>
				</template>
			</CardRow>
			<CardRow>
				<template #col0>
					<span class="risks-cell" v-one-tooltip="model.residualAchieved.join(', ')" @click="goToRisks(model.residualAchieved, [])">{{
						$t('risk.overview.residualAchieved')
					}}</span>
				</template>
				<template #col_end>
					<template v-if="model.anyResidualAchievedEvent">
						<i class="bi bi-exclamation-triangle orange" v-one-tooltip="$t('risk.acceptableAchievedEvent')"></i>
						&nbsp;
					</template>
					<span class="green">{{ model.residualAchieved.length }}</span>
				</template>
			</CardRow>
			<CardRow>
				<template #col0>
					<span class="risks-cell" v-one-tooltip="model.underAcceptable.join(', ')" @click="goToRisks(model.underAcceptable, [])">
						{{ $t('risk.overview.underAcceptable') }}
					</span>
				</template>
				<template #col_end>
					<span class="green">{{ model.underAcceptable.length }}</span>
				</template>
			</CardRow>
		</table>
	</div>
</template>
